import { SEOFAQInput, SEOHowToInput } from '@jusbrasil-web/shared-utils-seo'
import Head from 'next/head'

import { getMetaTags } from './meta-tags'
import { getStructuredData } from './structured-data'

export interface BlogHeadProps {
  title: string
  blogLabel: string
  canonicalUrl: string
  description: string
  imageAlternativeText: string
  keywords: string[]
  hasEmbeddedVideo?: boolean
  faqItems?: SEOFAQInput[]
  howTo?: SEOHowToInput
  structuredDataContext?: {
    isJusAcademyPost: boolean
    publishedAt?: number | null
    publisher?: {
      fullname?: string | null
      url?: string | null
    } | null
    articleBody?: string | null
  }
}

export function BlogHead(blogProps: BlogHeadProps) {
  const { title, canonicalUrl, hasEmbeddedVideo } = blogProps
  const metatags = getMetaTags(blogProps)
  const structuredData = getStructuredData(blogProps)

  return (
    <Head>
      <title>{title}</title>
      <meta
        name="robots"
        content={hasEmbeddedVideo ? 'index,follow,max-video-preview:-1' : 'index,follow'}
      />
      <link rel="canonical" href={canonicalUrl} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      {metatags.map((props, idx) => (
        <meta {...props} key={idx} />
      ))}
    </Head>
  )
}
